export class TesteeLoginRequestDTO {
    testeeId: string;
    code: string;
}